// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Icon from '../../../../components/icons/Icon';
import ElementSearchPopup from './ElementSearchPopup';
import TooltipSource from '../../../../components/tooltips/TooltipSource';
import PopupPanel from '../../../../components/popupPanel/PopupPanel';
import PopupTrigger from '../../../../components/popupPanel/PopupTrigger';

// Util
import searchPopupStayActivePredicate from './searchPopupStayActivePredicate';

// Constants
import { PopupIds, PopupSections } from '../../../../components/popupPanel/popupConstants';

// Styles
import '../HeaderUtil.scss';

const SearchUtil = ({ currentUser, tooltipEnabled }) => (
    <div className="HeaderUtil ElementSearchUtil">
        <TooltipSource
            tooltipText="Search"
            shortcut={['command', 'f']}
            distance={0}
            enabled={tooltipEnabled}
            delay={700}
            triggerOnMouseEnter
        >
            <PopupTrigger
                popupId={PopupIds.SEARCH}
                stayActivePredicate={searchPopupStayActivePredicate}
                className="button-search header-util-button"
                closeSection={PopupSections.HEADER}
            >
                {() => (
                    <div className="header-util-button-content">
                        <Icon name="nav-search" />
                    </div>
                )}
            </PopupTrigger>
        </TooltipSource>
        <PopupPanel popupId={PopupIds.SEARCH} className="ElementSearchPopup">
            <ElementSearchPopup />
        </PopupPanel>
    </div>
);

SearchUtil.propTypes = {
    isGuest: PropTypes.bool,
    children: PropTypes.element,
    notifications: PropTypes.object,
    activeNotifications: PropTypes.object,
    notificationsCount: PropTypes.number,
    currentUser: PropTypes.object,
    fetchedTime: PropTypes.number,
    forcedPoll: PropTypes.number,
    fetchNotificationUsers: PropTypes.func,
    fetchNotificationBoards: PropTypes.func,
    fetchModified: PropTypes.func,
    markBoardsAsSeen: PropTypes.func,
    notificationUserIds: PropTypes.array,
    notificationsReady: PropTypes.bool,
    tooltipEnabled: PropTypes.bool,
};

export default SearchUtil;
